export const options = [
    { name: "All Policies", value: "all" },
    { name: "Policy 1", value: "policy1" },
    { name: "Policy 2", value: "policy2" },
  ];
export const locations = [
  { name: "Burlington, Vermont", value: "burlington" },
  { name: "Hartford, Connecticut", value: "hartford" },
  { name: "Boston, Massachusetts", value: "boston" },
]